import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class Inscription {
    static jsonMap = {
        email: { key: 'email', optional: true, default: '' },
        dateDebut: { key: 'dateDebut', converter: new DateConverter(), optional: true },
        dateFin: { key: 'dateFin', converter: new DateConverter(), optional: true },
        structureJuridique: { key: 'structureJuridique', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        tvaIntra: { key: 'tvaIntra', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        pays: { key: 'pays', optional: true, default: '' },
        cedex: { key: 'cedex', optional: true, default: '' },
        telFixe: { key: 'telFixe', optional: true, default: '' },
        telPortable: { key: 'telPortable', optional: true, default: '' },
        fax: { key: 'fax', optional: true, default: '' }
    };

    email: string;
    dateDebut: moment.Moment;
    dateFin: moment.Moment;
    structureJuridique: string;
    raisonSociale: string;
    siret: string;
    tvaIntra: string;
    adresse: string;
    codePostal: string;
    ville: string;
    pays: string;
    cedex: string;
    telFixe: string;
    telPortable: string;
    fax: string;
}
